export default __webpack_public_path__ + "static/media/left.f3edc2e1.png";